'use strict';

export default class ShowMoreBlock {
	constructor(btn, container, pagination, callback) {
		if(!btn || !container) return false;
		this.btn = btn;
		this.container = container;
		this.pagination = pagination;
		this.actionUrl = btn.href;
		if(callback) this.callback = callback;
		this.init();
	}

	init() {
		this.btn.addEventListener('click', (e)=>{
			e.preventDefault();
			this.request();
		})
	}

	request() {
		this.btn.classList.add('is-loading');
		this.container.classList.add('is-loading');

		$.ajax({
			type: 'POST',
			url: this.actionUrl,
			dataType: 'json',
			success: (res)=> {
				if (res.TEMPLATE) {
					$(this.container).append($(res.TEMPLATE));

				}
				if (res.PAGINATION) {
					$(this.pagination).html($(res.PAGINATION));
				}
				if (this.callback) this.callback();
				this.btn.classList.remove('is-loading');
				this.container.classList.remove('is-loading');
			}
		});
	}
}
